export default[
    {
        path: '/cargohoraria/trabalhador/cadastro/:trabalhador_id/:tomador_id',
        name: 'cadastro de cargo horarias do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/cargohoraria/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro de cargo horarias do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/cargohoraria/trabalhador/lista/:id/:tomador_id',
        name: 'lista de cargo horarias do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/cargohoraria/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar cargo horarias do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]